import type { BlogTileData } from '@bulknutrients/bulk-shared-lib/interfaces/Blog';
import { BlogCard } from '@components/Blog/BlogCard';
import { featuredBlogs } from '../../data/featuredBlogs';
import { EmblaCarousel } from './Carousel';

export function FeaturedBlogsCarousel() {
  return (
    <EmblaCarousel
      slides={featuredBlogs.map((blog, idx) => (
        <BlogCard
          blog={blog as unknown as BlogTileData}
          key={`featuredBlog${idx}`}
          className="w-xs sm:w-[400px]"
        />
      ))}
    />
  );
}
